<section class="flex flex-row justify-start items-center" [ngClass]="classList">
  <mat-icon>{{ iconName }}</mat-icon>
  <ng-content></ng-content>
</section>
